import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-main">
                    <div className="footer-brand">
                        <h2 className="footer-logo">doazhu<span>.pro</span></h2>
                        <p className="footer-tagline">Fullstack разработчик</p>
                    </div>
                    
                    <nav className="footer-nav">
                        <Link to="/" className="footer-link cursor-target">Главная</Link>
                        <Link to="/about" className="footer-link cursor-target">Обо мне</Link>
                        <Link to="/work" className="footer-link cursor-target">Работы</Link>
                        <Link to="/contact" className="footer-link cursor-target">Контакты</Link>
                    </nav>
                </div>

                <div className="footer-divider"></div>

                <div className="footer-bottom">
                    <div className="footer-contacts">
                        <a href="mailto:me@doazhu.pro" className="footer-contact-item cursor-target">
                            <span className="contact-label">Email</span>
                            <span className="contact-value">me@doazhu.pro</span>
                        </a>
                        <a href="https://doazhu.pro" target="_blank" rel="noopener noreferrer" className="footer-contact-item cursor-target">
                            <span className="contact-label">Website</span>
                            <span className="contact-value">doazhu.pro</span>
                        </a>
                    </div>
                    
                    <div className="footer-social">
                        <a href="https://t.me/Doazhu" target="_blank" rel="noopener noreferrer" className="social-link cursor-target" aria-label="Telegram">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
                            </svg>
                        </a>
                        <a href="https://github.com/Doazhu" target="_blank" rel="noopener noreferrer" className="social-link cursor-target" aria-label="GitHub">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                            </svg>
                        </a>
                        <a href="https://vk.com/doazhu" target="_blank" rel="noopener noreferrer" className="social-link cursor-target" aria-label="VK">
                            <svg viewBox="0 0 24 24" fill="currentColor">
                                <path d="M15.684 0H8.316C1.592 0 0 1.592 0 8.316v7.368C0 22.408 1.592 24 8.316 24h7.368C22.408 24 24 22.408 24 15.684V8.316C24 1.592 22.408 0 15.684 0zm3.692 17.123h-1.744c-.66 0-.864-.525-2.05-1.727-1.033-1-1.49-1.135-1.744-1.135-.356 0-.458.102-.458.593v1.575c0 .424-.135.678-1.253.678-1.846 0-3.896-1.118-5.335-3.202C4.624 10.857 4 8.648 4 8.19c0-.254.102-.491.593-.491h1.744c.44 0 .61.203.78.677.863 2.49 2.303 4.675 2.896 4.675.22 0 .322-.102.322-.66V9.721c-.068-1.186-.695-1.287-.695-1.71 0-.203.17-.407.44-.407h2.744c.373 0 .508.203.508.643v3.473c0 .372.17.508.271.508.22 0 .407-.136.813-.542 1.27-1.422 2.18-3.61 2.18-3.61.119-.254.322-.491.763-.491h1.744c.525 0 .644.27.525.643-.22 1.017-2.354 4.031-2.354 4.031-.186.305-.254.44 0 .78.186.254.796.779 1.203 1.253.745.847 1.32 1.558 1.473 2.05.17.49-.085.744-.576.744z"/>
                            </svg>
                        </a>
                    </div>
                </div>

                <div className="footer-copyright">
                    <span>© 2026 doazhu.pro</span>
                    <span className="footer-made">Made with 💚</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
